import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import api from '../utils/api'

export interface AcademicUnitTypeOption {
  categoryId: string
  categoryName: string
}

async function fetchAcademicUnitTypes (): Promise<AcademicUnitTypeOption[]> {
  const { data } = await api.get('/api/acad_units/', {
    headers: { Accept: 'application/cdg' }
  })
  const rows = (data?.data ?? []) as Array<{ data?: { categoryId?: string, categoryName?: string }, categoryId?: string, categoryName?: string }>
  return rows
    .map((item) => ({
      categoryId: String(item?.data?.categoryId ?? item?.categoryId ?? ''),
      categoryName: String(item?.data?.categoryName ?? item?.categoryName ?? '')
    }))
    .filter((t) => t.categoryName.length > 0)
}

export function useAcademicUnitTypesQuery (): UseQueryResult<AcademicUnitTypeOption[], unknown> {
  return useQuery({
    queryKey: ['academic_unit_types'],
    queryFn: fetchAcademicUnitTypes,
    staleTime: 10 * 60 * 1000
  })
}
